<template>
  <iframe
    v-if="src"
    :src="src"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
import { getPartnerData } from 'fleetmap-partners'

export default {
  name: 'ExternalReports',
  computed: {
    src() {
      const partnerData = getPartnerData()
      return partnerData && partnerData.externalReports && partnerData.externalReports.url
    }
  }
}
</script>

<style scoped>
iframe {
  border-width: 0;
}
</style>
